<template>
  <div class="d-flex flex-column full-width text-center">
    <div class="items mb-3 flex-grow-1">
      <GameItem v-for="(item, i) in items" :key="i" :item="item" :size="54" />
    </div>
    <h3 class="text-h6">
      {{ items.length }} free <span v-text="$tc('common.items', items.length)" />
    </h3>
  </div>
</template>

<script>
export default {
  props: {
    reward: {
      type: Object,
      required: true,
    },
    itemdb: {
      type: Object,
      required: true,
    },
  },
  computed: {
    items() {
      if (!this.reward.data?.items) return []

      const { itemdb } = this

      return this.reward.data.items.map(i => ({
        ...i,
        ...itemdb[i.name],
      }))
    },
  },
}
</script>

<style lang="scss" scoped>
.items {
  display: grid;
  position: relative;
  justify-items: center;
  align-items: center;
  grid-template-columns: repeat(auto-fit, minmax(54px, 1fr));
  grid-gap: 8px;

  .game-item {
    border: 1px solid rgba(grey, 0.2);
  }
}
</style>
